export enum SituacaoSolicitacaoEnum {

  aprovada = "Aprovada",
  indeferida = "Indeferida",
  pendente = "Pendente"
}
